import { render, staticRenderFns } from "./ProductDiscount.vue?vue&type=template&id=3c64ab56&"
import script from "./ProductDiscount.vue?vue&type=script&lang=js&"
export * from "./ProductDiscount.vue?vue&type=script&lang=js&"
import style0 from "./ProductDiscount.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QBreadcrumbs,QIcon,QBreadcrumbsEl,QBtn,QBtnDropdown,QList,QItem,QItemSection,QItemLabel,QInput,QBtnToggle,QTable,QTr,QTh,QDialog,QCard,QCardSection,QSpace,QSelect,QCardActions,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QBreadcrumbs,QIcon,QBreadcrumbsEl,QBtn,QBtnDropdown,QList,QItem,QItemSection,QItemLabel,QInput,QBtnToggle,QTable,QTr,QTh,QDialog,QCard,QCardSection,QSpace,QSelect,QCardActions})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
